<!--
 * @Description: 销售线索 - 转为潜在客户
 * @Author: mdb
 * @Date: 2022-08-15 16:11:21
 * @LastEditTime: 2023-06-26 15:50:17
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <a-form ref="formRef" :model="dataForm" :rules="formRules" autocomplete="off" scrollToFirstError>
        <dc-layout-card title="基础信息" :span="6">
          <dc-form-item label="客户名称" name="customerName" :rules="formRules.input">
            <CosInput v-model:value="dataForm.customerName" :maxlength="100" />
          </dc-form-item>
          <dc-form-item label="客户状态" name="status" :rules="formRules.select">
            <template #label>
              客户状态
              <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                <template #title>
                  <div v-for="item in customerStatusEnum" :key="item.value">
                    <p>{{ item.label }}{{ item.desc ? `：${item.desc}` : '' }}</p>
                  </div>
                </template>
                <ExclamationCircleOutlined style="margin-left: 2px; font-size: 14px" />
              </a-tooltip>
            </template>
            <a-select v-model:value="dataForm.status" :disabled="true" :options="customerStatusEnumFilter"
              placeholder="请选择" allowClear />
          </dc-form-item>
          <dc-form-item label="来源渠道" name="channel" :rules="formRules.select" class="form-item_compact">
            <a-input-group compact>
              <ParamCodeCascader v-model:value="dataForm.channel" :options="paramCodeData.lbu_source_channel"
                style="width: 33%" />
              <dc-form-item name="channelExplain" :span="24" style="width: 67%" class="last-compact">
                <CosInput v-model:value="dataForm.channelExplain" :maxlength="100" />
              </dc-form-item>
            </a-input-group>
          </dc-form-item>
          <dc-form-item label="客户类型" name="customerType" :rules="formRules.select" formType="view">
            <a-select v-model:value="dataForm.customerType" :options="customerTypeEnum" placeholder="请选择" allowClear />
          </dc-form-item>
          <dc-form-item label="业务收入等级" name="monthIncome" :rules="formRules.selectValidate">
            <ParamCodesSelect v-model:value="dataForm.monthIncome" :options="paramCodeData.lbu_important"
              placeholder="请选择" allowClear />
          </dc-form-item>
          <dc-form-item label="业务类型" name="businessType" :rules="formRules.select">
            <CosSelect
              v-model:value="dataForm.businessType"
              :options="businessTypeEnum"
              placeholder="请选择"
              allowClear
            />
          </dc-form-item>
          <a-col :span="12" />
          <dc-form-item label="备注" :span="12" name="remark">
            <a-textarea v-model:value="dataForm.remark" :maxlength="2000" placeholder="请输入" />
          </dc-form-item>
        </dc-layout-card>

        <dc-layout-card title="目的地国家" :span="4">
          <template #subTitle>
            <a-button type="primary" ghost @click="handleDemandInfoAdd()">新增</a-button>
          </template>
          <MultipleItem  :line="false">
            <template v-for="(item, index) in dataForm.business?.demandInfo" :key="index">
              <dc-form-item :label="index ? '' : '目的地国家'" :class="index ? 'no-form-label' : ''"
                :name="['business', 'demandInfo', index, 'countryId']"
                :rules="{
                    message: '请选择',
                    validator: selectForNumberValidate,
                    required: true
                  }"
                >
                <ParamCodesSelect v-model:value="item.countryId" :options="paramCodeData.lbu_demand_country" allowClear />
              </dc-form-item>
              <dc-form-item :label="index ? '' : '出货渠道'" :class="index ? 'no-form-label' : ''"
                :name="['business', 'demandInfo', index, 'shippingChannel']">
                <ParamCodesSelect v-model:value="item.shippingChannel" :options="paramCodeData.lbu_shipping_channel" mode="multiple" />
              </dc-form-item>
              <dc-form-item :label="index ? '' : 'TPR（票数/月）'" :class="index ? 'no-form-label' : ''"
                :name="['business', 'demandInfo', index, 'potentialBusinessVolume']">
                <template #label>
                  <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                    <template #title>
                      <p>潜力业务量（票数/月）</p>
                    </template>
                    <span>{{ `${index ? '' : 'TPR（票数/月）'}` }}</span>
                    <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
                  </a-tooltip>
                </template>
                <CosInputNumber v-model:value="item.potentialBusinessVolume" :min="0" :maxlength="15" cos-type="money" style="width: 100%" />
              </dc-form-item>
              <dc-form-item :label="index ? '' : 'TPR（元/月）'" :class="index ? 'no-form-label' : ''"
                :name="['business', 'demandInfo', index, 'amount']">
                <template #label>
                  <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                    <template #title>
                      <p>发货潜力（元/月）</p>
                    </template>
                    <span>{{ `${index ? '' : 'TPR（元/月）'}` }}</span>
                    <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
                  </a-tooltip>
                </template>
                <CosInputNumber v-model:value="item.amount" :min="0" :maxlength="15" cos-type="money"
                  style="width: 100%" />
              </dc-form-item>
              <dc-form-item
                :label="index ? '' : 'TPR（KG/月）'"
                :class="index ? 'no-form-label' : ''"
                :name="['business', 'demandInfo', index, 'tprWeight']"  :span="6"
              >
                <template #label>
                  <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                    <template #title>
                      <p>发货潜力（KG/月）</p>
                    </template>
                    <span>{{ `${index ? '' : 'TPR（KG/月）'}` }}</span>
                    <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px"/>
                  </a-tooltip>
                </template>
                    <div class="flex">
                <CosInputNumber
                  v-model:value="item.tprWeight"
                  :min="0"
                  :maxlength="15"
                  cos-type="money"
                  style="width: 100%"
                />
                <a-button type="text" danger style="padding: 0 0 0 12px"
                    v-if="dataForm.business?.demandInfo && dataForm.business?.demandInfo.length > 1"
                    @click="handleDemandInfoDel(index)">删除
                  </a-button>
                </div>
              </dc-form-item>
              <a-col :span="24" />
            </template>
          </MultipleItem>
        </dc-layout-card>

        <template v-for="(item, index) in dataForm.createOrUpdateList" :key="index">
          <dc-layout-card :title="`商机${index + 1}`" :span="6">
            <template #subTitle>
              <div class="subtitle-content" v-if="index === 0">
                <p class="subtitle">(至少创建一个商机才能转为潜在客户)</p>
                <a-button type="primary" @click="handleBusinessAdd()">新增</a-button>
              </div>
              <a-button danger @click="handleBusinessDel(index)" v-else>删除</a-button>
            </template>
            <dc-form-item :name="['createOrUpdateList', index, 'originCountry']" label="始发地国家"  :rules="formRules.select">
              <CustomerArea
                v-model:value="item.originCountry"
                change-on-select
                showSearch
                :display-level="1"
                allowClear
              />
            </dc-form-item>
            <dc-form-item label="目的地国家" :name="['createOrUpdateList', index, 'requiredCountry']"
              :rules="formRules.selectValidate">
              <ParamCodesSelect v-model:value="item.requiredCountry" :options="paramCodeData.lbu_demand_country"
                placeholder="请选择" allowClear @change="(val: any) => handleCountryChange(index, val)" />
            </dc-form-item>
            <dc-form-item label="云途产品" :name="['createOrUpdateList', index, 'product']"
              :rules="formRules.selectValidate">
              <CosSelect v-model:value="item.product" :options="shippingChannel[index]"
                :fieldNames="{ label: 'cnName', value: 'paramId' }" allowClear />
            </dc-form-item>
            <dc-form-item label="客户归属区域" :name="['createOrUpdateList', index, 'warehouseAttribution']"
              :rules="formRules.select">
              <ParamCodeCascader v-model:value="item.warehouseAttribution"
                :options="paramCodeData.lbu_warehouse_city" />
            </dc-form-item>
            <dc-form-item label="商机状态" :name="['createOrUpdateList', index, 'status']" :rules="formRules.select">
              <template #label>
                <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                  <template #title>
                    <div v-for="item in businessStatusEnumFilter" :key="item.value">
                      <p>{{ item.label }}{{ item.desc ? `：${item.desc}` : '' }}</p>
                    </div>
                  </template>
                  <span>商机状态</span>
                  <ExclamationCircleOutlined style="margin-left: 2px; font-size: 14px" />
                </a-tooltip>
              </template>
              <a-select v-model:value="item.status" :options="businessStatusEnumFilter" placeholder="请选择" onchange=""
                allowClear />
            </dc-form-item>
            <dc-form-item label="商机类型" :name="['createOrUpdateList', index, 'saleChanceType']"
              :rules="formRules.saleChanceType">
              <ParamCodesSelect v-model:value="item.saleChanceType" :options="paramCodeData.lbu_sale_chance_type"
                allowClear />
            </dc-form-item>
            <dc-form-item label="竞争对手" :name="['createOrUpdateList', index, 'competitors']" :rules="formRules.select">
              <ParamCodeCascader v-model:value="item.competitors" :options="paramCodeData.lbu_logistics_service_provider"
                placeholder="请选择" multiple mode="multiple" max-tag-count="responsive" allowClear />
            </dc-form-item>
            <dc-form-item label="协助部门" :name="['createOrUpdateList', index, 'assistDepartment']">
              <ParamCodesSelect v-model:value="item.assistDepartment" :options="paramCodeData.lbu_assistance_department"
                placeholder="请选择" allowClear />
            </dc-form-item>
            <dc-form-item label="OPR票数" :name="['createOrUpdateList', index, 'mau']" :rules="ifB2BProduct(index) ? undefined : formRules.mau">
              <template #label>
                <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                  <template #title>
                    <p>潜力月均发货量</p>
                  </template>
                  <span>OPR票数</span>
                  <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
                </a-tooltip>
              </template>
              <CosInputNumber v-model:value="item.mau" :min="0" :maxlength="15" placeholder="请输入OPR票数"
                oninput="value= value.length === 1 ? value.replace(/[^1-9]/g,''):value.replace(/[^\d]/g,'')" />
            </dc-form-item>
            <dc-form-item label="OPR金额" :name="['createOrUpdateList', index, 'planSaleAmount']"
              :rules="[{ required: !ifB2BProduct(index), message: '请输入OPR金额' }]">
              <template #label>
                <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                  <template #title>
                    <p>潜力月均销售额(元)</p>
                  </template>
                  <span>OPR金额</span>
                  <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
                </a-tooltip>
              </template>
              <CosInputNumber v-model:value="item.planSaleAmount" :min="0" :maxlength="15" placeholder="对应仓库及渠道的OPR金额"
                oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')" />
            </dc-form-item>
            <dc-form-item label="OCR票数" :name="['createOrUpdateList', index, 'committedShipment']"
              :rules="[{ required: item.status === 4 || item.status === 9 || item.status === 5 || item.status === 7, message: '请输入OCR票数' }]">
              <template #label>
                <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                  <template #title>
                    <p>客户承诺月均发货量</p>
                  </template>
                  <span>OCR票数</span>
                  <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
                </a-tooltip>
              </template>
              <CosInputNumber v-model:value="item.committedShipment" :min="0" :maxlength="15" placeholder="请输入OCR票数"
                oninput="value= value.length === 1 ? value.replace(/[^1-9]/g,''):value.replace(/[^\d]/g,'')" />
            </dc-form-item>
            <dc-form-item label="OCR金额" :name="['createOrUpdateList', index, 'committedSaleAmount']"
              :rules="[{ required: item.status === 4 || item.status === 9 || item.status === 5 || item.status === 7, message: '请输入OCR金额' }]">
              <template #label>
                <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
                  <template #title>
                    <p>客户承诺月均销售额（元）</p>
                  </template>
                  <span>OCR金额</span>
                  <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
                </a-tooltip>
              </template>
              <CosInputNumber v-model:value="item.committedSaleAmount" :min="0" :maxlength="15" placeholder="请输入OCR金额"
                oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')" />
            </dc-form-item>

            <template v-if="ifB2BProduct(index)">
              <dc-form-item label="OPR重量（KG）" :name="['createOrUpdateList', index, 'oprWeight']" :rules="formRules.input">
                <CosInputNumber
                  style="width: 100%"
                  :min="0"
                  :maxlength="15"
                  cos-type="money"
                  v-model:value="item.oprWeight"
                  placeholder="请输入"
                  oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
                />
              </dc-form-item>
              <dc-form-item label="OCR重量（KG）" :name="['createOrUpdateList', index, 'ocrWeight']">
                <CosInputNumber
                  style="width: 100%"
                  :min="0"
                  :maxlength="15"
                  cos-type="money"
                  v-model:value="item.ocrWeight"
                  placeholder="请输入"
                  oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
                />
              </dc-form-item>
              <dc-form-item label="OPR方数（m³）" :name="['createOrUpdateList', index, 'oprCube']">
                <CosInputNumber
                  style="width: 100%"
                  :min="0"
                  :maxlength="15"
                  cos-type="money"
                  v-model:value="item.oprCube"
                  placeholder="请输入"
                  oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
                />
              </dc-form-item>
              <dc-form-item label="OCR方数（m³）" :name="['createOrUpdateList', index, 'ocrCube']">
                <CosInputNumber
                  style="width: 100%"
                  :min="0"
                  :maxlength="15"
                  cos-type="money"
                  v-model:value="item.ocrCube"
                  placeholder="请输入"
                  oninput="value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
                />
              </dc-form-item>
              <dc-form-item label="发货频次（次/月）" :name="['createOrUpdateList', index, 'shipmentFrequency']" :rules="formRules.input">
                <CosInputNumber
                  style="width: 100%"
                  :min="0"
                  :maxlength="15"
                  cos-type="money"
                  v-model:value="item.shipmentFrequency"
                  placeholder="请输入发货频次"
                  oninput="value=value.length === 1 ? value.replace(/[^1-9]/g, '') : value.replace(/[^\d.]/g, '')"
                />
              </dc-form-item>
              <dc-form-item label="货物类型"  :name="['createOrUpdateList', index, 'goodsCategory']" :rules="formRules.select">
                <ParamCodesSelect
                  v-model:value="item.goodsCategory"
                  :options="paramCodeData.lbu_sales_category"
                  allowClear
                  mode="multiple"
                />
              </dc-form-item>
            </template>


            <dc-form-item label="竞对情况" :span="12" :name="['createOrUpdateList', index, 'competitionSituation']"
              :rules="formRules.competitionSituation">
              <CosTextarea v-model:value="item.competitionSituation" :maxlength="2000"
                placeholder="描述竞争对手所释放给该客户的具体价格，账期或其他活动策略，转运时间，货量要求等" />
            </dc-form-item>
            <dc-form-item label="客户情况" :span="12" :name="['createOrUpdateList', index, 'customerSituation']"
              :rules="formRules.customerSituation">
              <CosTextarea v-model:value="item.customerSituation" :maxlength="2000"
                placeholder="客户的营业模式，最近一次沟通和拜访的情况和进度，遇到的问题" />
            </dc-form-item>
            <dc-form-item label="所需支持" :span="12">
              <CosTextarea v-model:value="item.requiredSupport" :maxlength="2000" placeholder="针对客户商机转换所需要的支持和帮助内容" />
            </dc-form-item>
            <dc-form-item label="备注" name="remark" :span="12">
              <CosTextarea v-model:value="item.remark" :maxlength="2000" placeholder="其他需要特殊说明的内容，客户货品重量情况等" />
            </dc-form-item>
          </dc-layout-card>
        </template>
      </a-form>

      <cos-footer-button v-model:value="dataForm" :formRef="formRef" :permissionPage="permissionPotential"
        :resetValue="initForm" :loading="loading" :disabled="false" @submit="handleSubmit" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { ref, reactive, onBeforeMount, computed } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { message } from '@dc-platform/dc-components'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { goBack } from '@/hooks/cosRouter'
import { customerStatusEnum } from '../dataConfig'
import { businessTypeEnum, customerTypeEnum, businessStatusEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { clueToPotential } from '@/api/yuntuSales/chanceManage'
import { salesClueDetail } from '@/api/yuntuSales/clueManage'
import { countryChannelRelevance } from '@/api/yuntuSales/operationsManage'
import { selectForNumberValidate } from '@/utils/validate'
import { paramCodesDataFilter } from '@/utils/index'
import type { Rule } from 'ant-design-vue/es/form'
import type { FormInstance } from 'ant-design-vue'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuSalesCluePotentialParams } from '@/typings/api/clueManage'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import calc from '@/utils/calc'
import CustomerArea from '@/components/CustomerArea'

const route = useRoute()
const permissionPotential = {
  edit: 'lbu_clue_potential_btn',
  save: 'lbu_clue_potential_btn'
}

const queryClueId = computed(() => route.query.clueId as string)

const businessStatusEnumFilter = computed(() => {
  return businessStatusEnum.filter((item) => item.value === 0)
})
const customerStatusEnumFilter = computed(() => {
  return customerStatusEnum.map((item) => {
    if (item.value === 13) {
      item.disabled = true
    }
    return { ...item }
  })
})

const ifB2BProduct = (index: any) => {
  const item = dataForm.createOrUpdateList[index]
  const product = item.product
  if (!product) return false
  const findOne = shippingChannel.value[index].find((item) => item.paramId === product)
  return findOne?.comment?.toUpperCase().includes('B2B') === true
}

const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  lbu_source_channel: [], // 来源渠道
  lbu_important: [], // 月潜在收入
  lbu_demand_country: [], // 目的地国家
  lbu_warehouse_city: [], // 客户归属区域
  lbu_logistics_service_provider: [], // 竞争对手
  lbu_assistance_department: [], // 协助部门
  lbu_sale_chance_type: [], // 商机类型
  lbu_shipping_channel: [],  //出货渠道
  lbu_sales_category: []
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_important',
      'lbu_source_channel',
      'lbu_demand_country',
      'lbu_warehouse_city',
      'lbu_logistics_service_provider',
      'lbu_assistance_department',
      'lbu_sale_chance_type',
      'lbu_shipping_channel',
      'lbu_sales_category'
    ]
  }).then((res) => {
    // 递归过滤业务参数状态
    res.data = paramCodesDataFilter(res.data, 0)
    paramCodeData.value = res.data
  })
}

// 获取线索详情
const getClueDetail = () => {
  salesClueDetail({
    clueId: queryClueId.value
  }).then((res) => {
    if (res.data) {
      dataForm.customerName = res.data.customerName || undefined
      dataForm.channel = res.data.channel || undefined
      dataForm.channelExplain = res.data.channelExplain || undefined
      dataForm.customerType = res.data.customerType || undefined
      dataForm.businessType = res.data.businessType || undefined
      dataForm.monthIncome = res.data.business?.monthIncome || undefined
      dataForm.business = { id: res.data.business?.id, demandInfo: res.data.business?.demandInfo || [] }
      if (!dataForm.business.demandInfo?.length) {
        handleDemandInfoAdd()
      }
      dataForm.remark = res.data.remark || undefined
      if (res.data.customerSerial) {
        dataForm.status = 11
      }
      setTimeout(() => formRef.value?.clearValidate(), 10)
    }
  })
}

const handleDemandInfoAdd = () => {
  dataForm.business?.demandInfo?.push({
    countryId: undefined,
    amount: undefined,
    potentialBusinessVolume: undefined,
    shippingChannel: undefined
  })
}

const handleDemandInfoDel = (index: number) => {
  dataForm.business?.demandInfo?.splice(index, 1)
}

onBeforeMount(() => {
  getByParamCodes()
  getClueDetail()
})
const initForm: LbuSalesCluePotentialParams.RootObject = reactive({
  status: 10,
  createOrUpdateList: [{ originCountry: '100000000000000000' }],
  business: { demandInfo: [{}] }
})
const formRef = ref<FormInstance>()
const dataForm: LbuSalesCluePotentialParams.RootObject = reactive(cloneDeep(initForm))
const formRules: Record<string, Rule[]> = {
  input: [{ required: true, message: '请输入' }],
  select: [{ required: true, message: '请选择' }],
  selectValidate: [{ required: true, validator: selectForNumberValidate, message: '请选择' }],
  mau: [{ required: true, message: '请输入OPR票数' }],
  saleChanceType: [{ required: true, message: '请选择商机类型' }],
  competitionSituation: [{ required: true, message: '请输入竞对情况' }],
  customerSituation: [{ required: true, message: '请输入客户情况' }]
}

const checkValidate = (value1: any, value2: any, message: string) => {
  if (!value1 && !value2) {
    return Promise.reject(new Error(message))
  }

  return Promise.resolve()
}

// 根据“目的地国家”的变化获取“出货渠道(云途产品)”
const shippingChannel = ref<ParamCodeItem[][]>([])
const getShippingChannel = (index: number, val: number) => {
  const params = { paramId: val }
  countryChannelRelevance(params).then((res) => {
    shippingChannel.value[index] = res.data
  })
}
const handleCountryChange = (index: number, val?: number) => {
  if (val && val !== -9) getShippingChannel(index, val)
  dataForm.createOrUpdateList[index].product = undefined
  shippingChannel.value[index] = []
}

const handleBusinessAdd = () => {
  dataForm.createOrUpdateList.push({originCountry: '100000000000000000'})
}
const handleBusinessDel = (index: number) => {
  dataForm.createOrUpdateList.splice(index, 1)
  shippingChannel.value.splice(index, 1)
}

const loading = ref(false)
const handleSubmit = async () => {
  try {
    const params = cloneDeep(dataForm)
    params.clueId = queryClueId.value
    params.createOrUpdateList.forEach((item) => {
      item.saleChanceRefId = queryClueId.value
    })
    params.business.tpr = params.business?.demandInfo?.reduce((sum: number, item: any) => {
      if (item.amount != null) {
        return calc.Add(sum, item.amount || 0)
      }
      return calc.Add(sum, 0)
    }, 0)
    params.business.totalPotential = params.business?.demandInfo?.reduce((sum: number, item: any) => {
      if (item.potentialBusinessVolume != null) {
        return calc.Add(sum, item.potentialBusinessVolume || 0)
      }
      return calc.Add(sum, 0)
    }, 0)
    params.business.demandInfo = params.business?.demandInfo?.filter((item: any) => {
      const allNull = item.countryId === null && item.amount === null && item.potentialBusinessVolume === null && item.shippingChannel === null
      return !allNull
    })
    await clueToPotential(params)
    message.success('转潜客成功')
    goBack()
  } catch (errorInfo: any) {
    loading.value = false
  }
  loading.value = false
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuSalesCluePotential' }
</script>

<style lang="scss" scoped>
:deep(.dc-card-header-defaut-subtitle) {
  margin-left: 0;

  .subtitle-content {
    display: flex;
    width: 100%;
    align-items: flex-end;
    justify-content: space-between;

    .subtitle {
      font-size: 12px;
      line-height: 2.5;
    }
  }
}
</style>
